document.querySelectorAll(".faq").forEach(el => {
  el.addEventListener('click', () => {
    el.classList.toggle('active')
  })
})